import styled from "@emotion/styled";

export const StyleReset = styled.div`
  --atlassian-recommended-system-fonts: -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  --bxp-charlie-display-font-family: "Charlie Display",
    var(--atlassian-recommended-system-fonts);
  --bxp-charlie-text-font-family: "Charlie Text",
    var(--atlassian-recommended-system-fonts);

  .semibold {
    font-weight: 500;
  }

  img,
  svg {
    margin-bottom: 0;
  }

  input {
    max-width: none;
  }

  div.error {
    margin: 0;
  }

  p {
    font-family: inherit;
    font-size: inherit;
  }
`;
